import { type ImpactType, StakeholderCategoryType } from '~/types/types'
import { handleUndefined, handleUndefinedArray, horizontalDividerBlock } from '../common'
import { getIrisCategoryIcon, getSdgIcon } from './getIcon'
export const handleImpactContentInfo = (impacts: ImpactType[], locale) => {
  if (impacts && impacts.length) {
    return [
      {
        text: 'Our impacts',
        width: '*',
        style: ['blueHeader'],
      },
    ,
    ...impacts.flatMap((impact: ImpactType) => {
        if (impact.conceptId === 93919) {
          return []
        }
        const geographies = getGeographiesLabel(
          handleUndefinedArray(impact?.geographies),
        ).join(', ')
        const irisCategories = irisCategoriesLabel(
          handleUndefinedArray(impact?.irisCategories),
        ).join(', ')
        const stakeholderCategory = stakeholderCategoryMapper(impact?.stakeholderCategory ?? undefined)
        const hasSdgs = Boolean(impact?.sdgs?.length)
        const metadataColumns: any[] = []
        if (stakeholderCategory) {
          metadataColumns.push([
            {
              columns: [
                {
                  svg: `<svg width="57" height="49" viewBox="0 0 57 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.5781 23.0938C15.2969 23.375 14.9375 23.5156 14.5 23.5156C14.0625 23.5156 13.7031 23.375 13.4219 23.0938C13.1406 22.7812 13 22.4219 13 22.0156C13 21.6094 13.1406 21.2656 13.4219 20.9844C13.7031 20.6719 14.0625 20.5156 14.5 20.5156C14.9375 20.5156 15.2969 20.6719 15.5781 20.9844C15.8594 21.2656 16 21.6094 16 22.0156C16 22.4219 15.8594 22.7812 15.5781 23.0938ZM32.1719 21.6875C32.1719 23.4062 31.5625 24.9375 30.3438 26.2812C29.1562 27.625 27.7031 28.4062 25.9844 28.625V32.5156H28.9844V34.4844H13V29.5156H12.0156V25.4844C12.0156 25.2031 12.1094 24.9688 12.2969 24.7812C12.4844 24.5938 12.7188 24.5 13 24.5H16C16.2812 24.5 16.5156 24.5938 16.7031 24.7812C16.8906 24.9688 16.9844 25.2031 16.9844 25.4844V29.5156H16V32.5156H24.0156V28.5781C22.3906 28.3281 21 27.5312 19.8438 26.1875C18.7188 24.8438 18.1562 23.3438 18.1562 21.6875C18.1562 19.75 18.8438 18.0938 20.2188 16.7188C21.5938 15.3438 23.25 14.6562 25.1875 14.6562C27.125 14.6562 28.7656 15.3438 30.1094 16.7188C31.4844 18.0938 32.1719 19.75 32.1719 21.6875Z" fill="#8FA5AF"/>
                  </svg>`,
                  width: 40,
                  height: 40,
                  margin: [6, -10, 0, 0],
                },
                {
                  text: stakeholderCategory,
                  style: ['grayTextStakeholder'],
                },
              ],
            },
          ])
        }
        if (geographies.length) {
          metadataColumns.push([
            {
              columns: [
                {
                  svg: `<svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.9987 11.4173C8.22515 11.4173 7.48329 11.11 6.9363 10.563C6.38932 10.0161 6.08203 9.2742 6.08203 8.50065C6.08203 7.7271 6.38932 6.98524 6.9363 6.43826C7.48329 5.89128 8.22515 5.58398 8.9987 5.58398C9.77225 5.58398 10.5141 5.89128 11.0611 6.43826C11.6081 6.98524 11.9154 7.7271 11.9154 8.50065C11.9154 8.88367 11.8399 9.26295 11.6933 9.61681C11.5468 9.97068 11.3319 10.2922 11.0611 10.563C10.7903 10.8339 10.4687 11.0487 10.1149 11.1953C9.76099 11.3419 9.38172 11.4173 8.9987 11.4173V11.4173ZM8.9987 0.333984C6.83276 0.333984 4.75554 1.1944 3.22399 2.72595C1.69245 4.25749 0.832031 6.33472 0.832031 8.50065C0.832031 14.6257 8.9987 23.6673 8.9987 23.6673C8.9987 23.6673 17.1654 14.6257 17.1654 8.50065C17.1654 6.33472 16.305 4.25749 14.7734 2.72595C13.2419 1.1944 11.1646 0.333984 8.9987 0.333984V0.333984Z" fill="#8FA5AF"/>
                  </svg>`,
                  width: 15,
                  height: 15,
                  margin: [0, 3, 0, 0],
                },
                {
                  text: geographies,
                  style: ['grayText'],
                  margin: [-20, 7, 0, 0],
                },
              ],
            },
          ])
        }
        if (irisCategories.length) {
          metadataColumns.push([
            {
              columns: [
                getIrisCategoryIcon(),
                {
                  text: irisCategories,
                  style: ['grayText'],
                  margin: [-20, 6, 0, 0],
                },
              ],
            },
          ])
        }
        if (hasSdgs) {
          metadataColumns.push([
            {
              margin: [-20, 0, 0, 0],
              columns: [getSdgIcon(), getSdgImages(impact?.sdgs)],
            },
          ])
        }
        const validImpactSolutions = (impact?.impactSolutions || []).filter(solution => Boolean(solution?.concept?.label))
        return [
          horizontalDividerBlock(30, 770, [-5, 4, 0, 10]),
          {
            margin: [12, -12, 0, 0],
            columns: [
              {
                svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 0C10.4241 0 8.86371 0.310389 7.4078 0.913446C5.95189 1.5165 4.62902 2.40042 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C4.62902 21.5996 5.95189 22.4835 7.4078 23.0866C8.86371 23.6896 10.4241 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 10.608 23.748 9.228 23.268 7.932L21.348 9.852C21.516 10.56 21.6 11.28 21.6 12C21.6 14.5461 20.5886 16.9879 18.7882 18.7882C16.9879 20.5886 14.5461 21.6 12 21.6C9.45392 21.6 7.01212 20.5886 5.21178 18.7882C3.41143 16.9879 2.4 14.5461 2.4 12C2.4 9.45392 3.41143 7.01212 5.21178 5.21178C7.01212 3.41143 9.45392 2.4 12 2.4C12.72 2.4 13.44 2.484 14.148 2.652L16.08 0.72C14.772 0.252 13.392 0 12 0ZM20.4 0L15.6 4.8V6.6L12.54 9.66C12.36 9.6 12.18 9.6 12 9.6C11.3635 9.6 10.753 9.85286 10.3029 10.3029C9.85286 10.753 9.6 11.3635 9.6 12C9.6 12.6365 9.85286 13.247 10.3029 13.6971C10.753 14.1471 11.3635 14.4 12 14.4C12.6365 14.4 13.247 14.1471 13.6971 13.6971C14.1471 13.247 14.4 12.6365 14.4 12C14.4 11.82 14.4 11.64 14.34 11.46L17.4 8.4H19.2L24 3.6H20.4V0ZM12 4.8C10.0904 4.8 8.25909 5.55857 6.90883 6.90883C5.55857 8.25909 4.8 10.0904 4.8 12C4.8 13.9096 5.55857 15.7409 6.90883 17.0912C8.25909 18.4414 10.0904 19.2 12 19.2C13.9096 19.2 15.7409 18.4414 17.0912 17.0912C18.4414 15.7409 19.2 13.9096 19.2 12H16.8C16.8 13.273 16.2943 14.4939 15.3941 15.3941C14.4939 16.2943 13.273 16.8 12 16.8C10.727 16.8 9.50606 16.2943 8.60589 15.3941C7.70571 14.4939 7.2 13.273 7.2 12C7.2 10.727 7.70571 9.50606 8.60589 8.60589C9.50606 7.70571 10.727 7.2 12 7.2V4.8Z" fill="#5188ff "/>
              </svg>`,
                width: 20,
                height: 20,
              },
              {
                text: handleUndefined(impact?.concept?.label),
                style: ['blueTextLarge'],
              },
            ],
          },
          ...(metadataColumns.length
            ? [{
                margin: [0, 8, 0, 0],
                columns: metadataColumns,
              }]
            : []),
          ...(validImpactSolutions.length
            ? [{
                margin: [15, 8, 0, 0],
                text: 'Solutions delivering this impact:',
                style: 'message',
              }]
            : []),
          ...validImpactSolutions.map(solution => ({
            columns: [
              {
                margin: [12, 0, 0, 10],
                columns: [
                  {
                    svg: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 11h3v2h-3zM1 11h3v2H1zM13 1v3h-2V1zM4.92 3.5l2.13 2.14l-1.42 1.41L3.5 4.93zm12.03 2.13l2.12-2.13l1.43 1.43l-2.13 2.12zM12 6a6 6 0 0 1 6 6c0 2.22-1.21 4.16-3 5.2V19a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1.8c-1.79-1.04-3-2.98-3-5.2a6 6 0 0 1 6-6m2 15v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1zm-3-3h2v-2.13c1.73-.44 3-2.01 3-3.87a4 4 0 0 0-4-4a4 4 0 0 0-4 4c0 1.86 1.27 3.43 3 3.87z" fill="#5B7185"/>
                    </svg>`,
                    width: 15,
                      height: 15,
                      margin: [0, 3, 0, 0],
                  },
                  {
                    text: solution?.concept?.label,
                    style: ['message'],
                    margin: [-20, 6, 0, 0],
                  }
                ],
              },
            ]
          })),
          ...buildEvidenceContent((impact as any)?.evidenceLinks || [])
        ]
      })
    ]
  }
}

const buildEvidenceContent = (evidenceLinks: any[]) => {
  if (!evidenceLinks?.length) return []
  return [
    {
      margin: [15, 8, 0, 0],
      columns: [
        {
          text: 'Evidence',
          style: ['sectionLabel'],
        },
      ],
    },
    ...evidenceLinks.map((evidenceLink) => {
      const fileUrl = evidenceLink?.evidence?.internalUrl || evidenceLink?.evidence?.websiteUrl || ''
      const fileName = evidenceLink?.evidence?.filename || fileUrl || 'Evidence'
      const websiteUrl = evidenceLink?.evidence?.websiteUrl || ''
      return {
        margin: [15, 4, 0, 0],
        columns: [
          {
            width: '30%',
            stack: [
              { text: 'Description', style: ['messageBold'] },
              { text: evidenceLink?.description || '-', style: ['message'] },
            ],
          },
          {
            width: '70%',
            stack: [
              { text: evidenceLink?.evidence?.description || fileName, style: ['messageBold'] },
              ...(fileUrl
                ? [{
                    text: `File: ${fileName}`,
                    style: ['blueTextSmall'],
                    link: fileUrl,
                  }]
                : []),
              ...(websiteUrl && websiteUrl !== fileUrl
                ? [{
                    text: `URL: ${websiteUrl}`,
                    style: ['blueTextSmall'],
                    link: websiteUrl,
                  }]
                : []),
            ],
          },
        ],
      }
    }),
  ]
}

const getGeographiesLabel = (geographies: any) => {
  return geographies.map((geography: any) => {
    return geography?.label
  })
}

const irisCategoriesLabel = (irisCategories: any) => {
  return irisCategories.map((irisCategory: any) => {
    return irisCategory?.label
  })
}

const stakeholderCategoryMapper = (stakeholderCategory?: StakeholderCategoryType) => {
  switch(stakeholderCategory){
    case StakeholderCategoryType.NaturalEnvironment:
      return "Natural environment"
    case StakeholderCategoryType.People:
      return "People"
    case StakeholderCategoryType.PeopleAndNaturalEnvironment:
      return "People and natural environment"
  }
  return ''
}

const getSdgImages = (sdgs: any) => {
  const sdgImages: any = []
  if (!sdgs || !sdgs.length)
    return { text: 'N/A', style: ['grayText'], margin: [-10, 5, 0, 0] }

  if (sdgs.length > 3) {
    const reducedSdgs = sdgs.slice(0, 2)
    sdgImages.push(reducedSdgs, [
      sdgs[2],
      {
        text: '...',
        bold: true,
        fontSize: 18,
        margin: [7, 0, 0, 0],
      },
    ])
  } else sdgImages.push(sdgs)

  return sdgImages.map((sdgImage: any) => {
    return sdgSectionTableLayout(sdgImage)
  })
}

const sdgSectionTableLayout = (sdgs: any) => {
  const sdgImages = sdgs.map((sdg: any) => {
    if (sdg.text) return sdg
    else
      return {
        image: sdg.dataURL,
        width: 30,
        height: 30,
      }
  })
  return {
    layout: 'noBorders',
    margin: [-20, 0, 0, 0],
    table: {
      widths: ['*'],
      body: [[{ columns: sdgImages, columnGap: 3 }]],
    },
  }
}
